import "../../styles/familymember.css";
import FamilySelectClient from "./FamilySelectClient";
import FamilyHomeResponsive from "./FamilyHomeResponsive";
import FamilyChecklist from "./FamilyChecklist";
import FamilyHome from './FamilyHome'
import FamilyVitals from "./FamilyVitals";
import FamilySettings from "./FamilySettings";
import FamilyResetPassword from "./FamilyResetPassword";
import FamilyConsentGate from "./FamilyConsentGate";

const familyPages = [
  { path: "/family-select-client", element: <FamilySelectClient /> },
  { path: "/family-home", element: <FamilyHome /> },
  { path: "/family-checklist", element: <FamilyChecklist /> },
  { path: "/family-vitals", element: <FamilyVitals /> },
  { path: "/family-settings", element: <FamilySettings /> },
  { path: "/family-reset-password", element: <FamilyResetPassword /> },
];

// Every family page sits behind the confidentiality agreement.
export const familyMemberRoutes = familyPages.map(({ path, element }) => ({
  path,
  element: <FamilyConsentGate>{element}</FamilyConsentGate>,
}));

export const FAMILY_MEMBER_PATHS = familyMemberRoutes.map((route) => route.path);
